// extracted by mini-css-extract-plugin
module.exports = {"patternWrapper":"DecorativePattern_patternWrapper__NNWSd"};